'use client'

// src/label.web.tsx
import * as Label from "@radix-ui/react-label";
import * as Slot from "@rn-primitives/slot";
import * as React from "react";
import { Pressable as Pressable2, Text as RNText } from "react-native";
var Root2 = React.forwardRef(({ asChild, tabIndex = -1, ...props }, ref) => {
  const Component = asChild ? Slot.Pressable : Pressable2;
  return <Component ref={ref} tabIndex={tabIndex} {...props} />;
});
Root2.displayName = "RootWebLabel";
var Text2 = React.forwardRef(
  ({ asChild, nativeID, htmlFor, ...props }, ref) => {
    const Component = asChild ? Slot.Text : RNText;
    return <Label.Root asChild={!htmlFor} id={nativeID} htmlFor={htmlFor}><Component ref={ref} {...props} /></Label.Root>;
  }
);
Text2.displayName = "TextWebLabel";
export {
  Root2 as Root,
  Text2 as Text
};
